/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
    <section class="section section-white content-padded" onload="init()">
        <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="第三方名称">
                <div>
                    <el-select v-model="third_name"  placeholder="第三方名称" >
                        <el-option  v-for="third_name in thirdnamelist" :key="third_name.value" :label="third_name.label" :value="third_name.value"  :disabled="third_name.disabled">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="权益名称">
                <div>
                    <el-col :span="8"><el-input v-model="form.type_name" placeholder="权益名称"></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="权益类型">
                <div>
                    <el-select v-model="type"  placeholder="权益类型" >
                        <el-option  v-for="type in typelist" :key="type.value" :label="type.label" :value="type.value" :disabled="type.disabled">
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <!--<el-form-item label="每人限领">-->
                <!--<div>-->
                    <!--<el-col :span="8"><el-input v-model="form.type_num" placeholder=""></el-input></el-col>-->
                <!--</div>-->
            <!--</el-form-item>-->
            <el-form-item label="权益描述">
                <div>
                    <el-col :span="8"><el-input v-model="form.type_desc" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="额外参数">
                <div>
                    <el-col :span="8"><el-input v-model="form.type_param" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>


            <div class="section-footer with-border content-center">
                <el-button size="large" @click="backCancle">取消</el-button>
                <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
            </div>

        </el-form>
    </section>
</template>
<script>

    import { mapGetters } from 'vuex'

    import { setThirdsSetting } from '../../../api/third'

    export default {
        components: {
        },
        data () {
            return {
                shop_type_id: 0,
                submitLoading:false,
                form:{},
                thirdnamelist:[
                    {
                        value:'jh',
                        label:'交行'
                    }, {
                        value:'other',
                        label:'其他',
                        disabled: true,
                    },
                ],
                third_name:'',
                typelist:[
                    {
                    value: 'shopyhq',
                    label: '商城优惠券'
                    },
                    {
                    value: 'distributionyhq',
                    label: '多店铺优惠券',
                    disabled: true,
                    },
                    {
                    value: 'points',
                    label: '积分',
                    disabled: true,
                    },
                    {
                    value: 'deposit',
                    label: '余额',
                    disabled: true,
                    },
                ],
                type: '',
            }
        },
        methods: {
            submitItemsActionConfirm () {
                this.submitLoading = true

                this.form.third_name = this.third_name
                this.form.type = this.type
                console.log(this.form)
                setThirdsSetting(this.form).then(res => {
                    this.submitLoading = false
                    console.log(res.data)
                    if(res.data.data.code == 1){
                        this.$message({ type: 'error', message: res.data.data.msg})
                    }else{
                        this.$message({ type: 'success', message: res.data.data.msg})
                        this.$router.go(-1)
                    }

                    // if (this.$store.getters.login_type != 'distributor') {
                    //     this.$router.go(-1)
                    // }

                }).catch (error => {
                    this.submitLoading = false
                })
            },
            backCancle(){
                this.$router.go(-1)
            },
        },
        mounted () {
            this.shop_type_id = this.$route.query.shop_type_id
            // console.log(this.shop_type_id)
            if (this.shop_type_id) {
                getShopTypeInfo({shop_type_id: this.shop_type_id}).then(res => {
                    this.form = res.data.data
                })
            }
        }

    }
</script>

<style lang="scss">
    .bm-view {
        width: 100%;
        height: 300px;
    }
    #qqmap_rslist {
        border-right: 1px solid #e7e7eb;
    }
    #qqmap_container{
        float:left;
        width:800px;
        height:400px;
    }
    .checkbox {
        background-color: white;
        border-radius: 0px;
        border: 1px solid #d3d3d3;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// thirdsseting_editor.vue?0f1050bf